import fetch                from '../../../utils/browser-fetch';
import busyActionFactory    from '../../../busy';
import Errors               from '../../../errors';
import { addSuccessString } from '../../../success-dux';
import SuccessString        from '../../../success';

import {
    addError,
    dismissErrorsByType
} from '../../../errors-dux';

import {
    setUserData,
    refreshProgramNames
} from '../../../user-dux';

/******************
 * Initial state
 */
const initialState = {
    busyUserLocale: false,
    busyChangingPassword: false
};

/******************
 * Non-async action types
 */
export const BUSY_SET_USER_LOCALE = 'BUSY_SET_USER_LOCALE';
export const BUSY_CHANGING_PASSWORD = 'BUSY_CHANGING_PASSWORD';

/******************
 * Reducer
 */
export default function profileData( state = initialState, action ) {
    switch ( action.type ) {
        case BUSY_SET_USER_LOCALE:
            return {
                ...state,
                busyUserLocale: action.busy
            };

        case BUSY_CHANGING_PASSWORD:
            return {
                ...state,
                busyChangingPassword: action.busy
            };

        default:
            return state;
    }
}


/******************
 * Action creators
 */

const busySettingUserLocale = busyActionFactory( BUSY_SET_USER_LOCALE );
export function setUserLocale( code ) {
    const message = 'profile.page.localeSuccessMessage';
    return ( dispatch ) => {
        dispatch( busySettingUserLocale( true ) );

        return fetch( '/api/v1.0/user/locale', {
            method: 'post',
            body: { 
                locale: { 
                    code
                } 
            }
        } )
            .then( ( userData ) => {
                dispatch( setUserData( userData ) );
                dispatch( refreshProgramNames() );
                dispatch( addSuccessString( '', message, SuccessString.SUCCESS_PROFILE_SETUSERLOCALE ) );
                dispatch( busySettingUserLocale( false ) );
            } )
            .catch( ( error ) => {
                dispatch( addError( error, Errors.ERROR_PROFILE_SETUSERLOCALE ) );
                dispatch( busySettingUserLocale( false ) );
            } );
    };
}



const busyChangingPassword = busyActionFactory( BUSY_CHANGING_PASSWORD );
export function changePassword( oldPassword, newPassword ) {
    const message = 'profile.page.passwordSuccessMessage';
    return ( dispatch ) => {
        dispatch( busyChangingPassword( true ) );
        dispatch( dismissErrorsByType( Errors.ERROR_PROFILE_CHANGEPASSWORD ) );

        return fetch( '/api/v1.0/user/password', {
            method: 'put',
            body: { oldPassword, newPassword }
        } )
            .then( () => {
                dispatch( addSuccessString( true, message, SuccessString.SUCCESS_PROFILE_CHANGEPASSWORD ) );
                dispatch( busyChangingPassword( false ) );
            } )
            .catch( ( error ) => {
                dispatch( addError( error, Errors.ERROR_PROFILE_CHANGEPASSWORD ) );
                dispatch( busyChangingPassword( false ) );
            } );
    };
}